import { findAvailableLotMatch } from '../../utils/lotIdentity'
import { filterInteractiveLots } from '../../utils/lotInteraction'

type WaterImportLot = {
  id: string
  lotKey: string
  stage?: string
}

export const reconcileImportedWaterLot = (args: {
  row: Record<string, unknown>
  lots: WaterImportLot[]
  lotKeyById: Map<string, string>
}) => {
  const incomingLotId = String((args.row as any).lotId ?? '').trim()
  const incomingLotLabel = String((args.row as any).lot ?? '').trim()
  const interactiveLots = filterInteractiveLots(args.lots)
  const interactiveLotKeyById = new Map(
    interactiveLots.map((lot) => [String(lot.id), String(lot.lotKey ?? '')] as const)
  )

  if (incomingLotId) {
    const mappedLotLabel = interactiveLotKeyById.get(incomingLotId)
    if (mappedLotLabel) {
      ;(args.row as any).lot = mappedLotLabel
      ;(args.row as any).unmappedLot = ''
      return
    }

    const resolvedLotFromId = interactiveLots.length > 0
      ? findAvailableLotMatch(incomingLotId, interactiveLots)
      : { status: 'unmatched' as const }

    if (resolvedLotFromId.status === 'matched') {
      ;(args.row as any).lotId = resolvedLotFromId.match.id
      ;(args.row as any).lot = interactiveLotKeyById.get(resolvedLotFromId.match.id) ?? resolvedLotFromId.match.lotKey
      ;(args.row as any).unmappedLot = ''
      return
    }

    if (!incomingLotLabel) {
      const inactiveLotLabel = args.lotKeyById.get(incomingLotId) ?? incomingLotId
      ;(args.row as any).lotId = ''
      ;(args.row as any).unmappedLot = inactiveLotLabel
      ;(args.row as any).lot = ''
      return
    }
  }

  if (!incomingLotLabel) {
    ;(args.row as any).lotId = ''
    ;(args.row as any).unmappedLot = ''
    return
  }

  const resolvedLot = interactiveLots.length > 0
    ? findAvailableLotMatch(incomingLotLabel, interactiveLots)
    : { status: 'unmatched' as const }

  if (resolvedLot.status === 'matched') {
    ;(args.row as any).lotId = resolvedLot.match.id
    ;(args.row as any).lot = interactiveLotKeyById.get(resolvedLot.match.id) ?? resolvedLot.match.lotKey
    ;(args.row as any).unmappedLot = ''
    return
  }

  ;(args.row as any).lotId = ''
  ;(args.row as any).unmappedLot = incomingLotLabel
  ;(args.row as any).lot = ''
}